import { useState, useRef } from 'react';
import { SketchPicker } from 'react-color';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import CancelIcon from '@mui/icons-material/Cancel';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import ImageEditor from '../../common/ImageCropModal';

import { translate } from '../../helper';
import LocalStorage from '../../defined/localStorage';
import { useSelector } from 'react-redux';
import { Select, Space } from 'antd';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { copyUrlToClipboard } from '../../utils/CommonFunction';
import { ReactComponent as FileCopy } from '../../assets/image/svg/fileCopy.svg';

function OrderFormInfoModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(var(--fs-hero) * 15)',
          maxHeight: '80vh',
          background: '#FFFFFF',
          borderRadius: 'calc(var(--sp-md2) * 1.1)',
          boxShadow: '0px 10px 30px rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none'
        }}>
        <div
          style={{
            padding: 'calc(var(--sp-md2) * 1.5) calc(var(--sp-md2) * 1.9)',
            borderBottom: '1px solid #E5E7EB',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xxs) * 2)' }}>
            <InfoOutlinedIcon
              style={{ color: '#2563EB', fontSize: 'calc(var(--fs-xl) * 1.132075)' }}
            />
            <span style={{ fontWeight: 600, fontSize: 'var(--fs-md)' }}>
              {translate('customizableOrderForm')}
            </span>
          </div>
          <CloseIcon
            style={{ cursor: 'pointer', fontSize: 'calc(var(--fs-xs) * 1.8867925)' }}
            onClick={onClose}
          />
        </div>

        <div
          style={{
            padding: 'var(--sp-lg)',
            overflowY: 'auto',
            fontSize: 'calc(var(--fs-xs) * 1.3207)',
            lineHeight: 'var(--sp-lg)',
            color: '#374151'
          }}>
          <p>
            The order form is fully customizable and drives the mobile ordering experience for end
            users. It is designed to capture all required information upfront, enabling faster, more
            accurate order submission while eliminating confusion and miscommunication between
            parties.
          </p>

          <div
            style={{
              background: '#F9FAFB',
              border: '1px solid #E5E7EB',
              borderRadius: 'calc(var(--sp-xxs) * 2)',
              padding: 'calc(var(--sp-md2) * 1.133)',
              margin: 'calc(var(--sp-md2) * 1.5) 0'
            }}>
            <ul style={{ paddingLeft: 'calc(var(--sp-md2) * 1.7)', margin: 0 }}>
              <li>Administrators can add, remove, or reorder fields</li>
              <li>Designate specific fields as required</li>
              <li>Relabel fields to match workflows</li>
            </ul>
          </div>

          <p>
            Required fields must be completed before an order can be submitted, ensuring consistency
            and completeness on every transaction.
          </p>

          <div
            style={{
              background: '#EFF6FF',
              borderLeft: '4px solid #2563EB',
              padding: 'calc(var(--sp-md2) * 1.133)',
              borderRadius: 'var(--sp-sm)',
              fontSize: 'var(--fs-sm2)'
            }}>
            The built-in letter-number scanner is a standard platform component and cannot be
            removed; however, it can be relabeled to match your industry or use case, ensuring a
            seamless, intuitive user experience.
          </div>
        </div>
      </div>
    </Modal>
  );
}
function VinInfoModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(var(--fs-hero) * 13)',
          background: '#FFFFFF',
          borderRadius: 'calc(var(--sp-md2) * 1.133)',
          boxShadow: '0px 10px 30px rgba(0,0,0,0.2)',
          outline: 'none'
        }}>
        <div
          style={{
            padding: 'calc(var(--sp-md2) * 1.5) calc(var(--sp-md2) * 1.9)',
            borderBottom: '1px solid #E5E7EB',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'calc(var(--sp-xxs) * 2)' }}>
            <DirectionsCarIcon
              style={{ color: '#2563EB', fontSize: 'calc(var(--fs-xl) * 1.132075)' }}
            />
            <span style={{ fontWeight: 600, fontSize: 'var(--fs-md)' }}>
              {translate('vinInformation')}
            </span>
          </div>
          <CloseIcon
            style={{ cursor: 'pointer', fontSize: 'calc(var(--fs-xs) * 1.8867925)' }}
            onClick={onClose}
          />
        </div>

        <div
          style={{
            padding: 'calc(var(--sp-md2) * 1.133)',
            borderRadius: 'var(--sp-sm)',
            fontSize: 'var(--fs-sm2)'
          }}>
          <p>
            The built-in letter-number scanner is a standard platform component and cannot be
            removed; however, it can be relabeled to match your industry or use case, ensuring a
            seamless, intuitive user experience.
          </p>
        </div>
      </div>
    </Modal>
  );
}
const brand = JSON.parse(LocalStorage.getItem('branding'));

function TextField({ label, value, name, onChange }) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <fieldset
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
      key={label}>
      <label
        style={{
          fontWeight: '400',
          fontSize: 'calc(var(--fs-xs) * 1.50943)',
          lineHeight: 'calc(var(--sp-lg) * 1.132075)',
          color: '#000',
          marginBottom: 'var(--sp-xs)',
          textTransform: 'capitalize'
        }}>
        {translate(label)}
      </label>
      <input
        type="text"
        style={{
          borderRadius: 'calc(var(--sp-xxs) * 2)',
          border: `0.5px solid ${isFocused ? '#1976d2' : '#C8C8C8'}`,
          backgroundColor: '#F8F8F8',
          height: 'calc(var(--fs-xl)*1.88679) !important',
          transition: 'border-color 150ms ease'
        }}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </fieldset>
  );
}
function OrderInput({ value, name, onChange, showInfo, onInfoClick, showCopy, onCopy, copied }) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-sm)' }}>
      {showInfo && (
        <IconButton size="small" sx={{ p: 0, color: '#6B7280' }} onClick={onInfoClick}>
          <InfoOutlinedIcon style={{ fontSize: 'calc(var(--fs-xs) * 1.8867925)' }} />
        </IconButton>
      )}

      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          width: '100%',
          borderRadius: 'calc(var(--sp-xxs) * 2)',
          border: `0.5px solid ${isFocused ? '#1976d2' : '#C8C8C8'}`,
          backgroundColor: '#F8F8F8',
          padding: '0 calc(var(--sp-md2) * 1.132075)',
          fontSize: 'calc(var(--fs-xs) * 1.32075) !important',
          height: 'calc(var(--fs-xl)*1.88679) !important',
          transition: 'border-color 150ms ease'
        }}
      />
      {showCopy && (
        <button
          type="button"
          onClick={onCopy}
          style={{
            borderRadius: 'calc(var(--sp-xxs) * 2)',
            border: '1.5px solid #C8C8C8',
            background: '#F9FAFB',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 'calc(var(--sp-xxs) * 1.5)',
            color: '#3127a0',
            fontWeight: 700,
            fontSize: 'calc(var(--fs-xs) * 1.132075)',
            padding: 'calc(var(--sp-md2) * 0.7) calc(var(--sp-md2) * 1.2)',
            whiteSpace: 'nowrap',
            transition: 'all 0.3s ease',
            height:'calc(var(--fs-xl)*1.88679)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#D1D5DB';
            e.currentTarget.style.backgroundColor = '#F3F4F6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#E5E7EB';
            e.currentTarget.style.backgroundColor = '#F9FAFB';
          }}>
          <FileCopy
            style={{
              width: 'calc(var(--fs-xs) * 1.50943)',
              height: 'calc(var(--fs-xs) * 1.50943)'
            }}
          />
          <span>{copied ? 'Copied' : 'Copy'}</span>
        </button>
      )}
    </div>
  );
}

function SubHeader(props) {
  const { label, button, hyperlinkText, onClick, infoContent = false, setIsInfoOpen } = props;
  return (
    <div
      style={{
        display: 'inline-grid',
        alignItems: 'center',
        gridTemplateColumns: 'auto 1fr auto',
        width: '100%'
      }}>
      {label && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'calc(var(--sp-xxs) * 2)',
            padding:
              'calc(var(--sp-md2) * 1.88679) calc(var(--sp-md2) * 1.88679) calc(var(--sp-md2) * 1) 0',
            width: 'fit-content'
          }}>
          <span
            style={{
              fontSize: 'calc(var(--fs-xs) * 1.698113)',
              width: 'fit-content',
              lineHeight: 'calc(var(--sp-lg) * 1.27358)',
              fontWeight: '600'
            }}>
            {translate(label)}
          </span>
          {infoContent && (
            <IconButton
              size="small"
              aria-label="About this section"
              sx={{ color: '#6B7280', p: 0 }}
              onClick={() => setIsInfoOpen(true)}>
              <InfoOutlinedIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.8867925)' }} />
            </IconButton>
          )}
        </div>
      )}
      <div style={{ 
          height: "calc(var(--fs-xs)*0.13650)", 
          background: 'linear-gradient(90deg, rgba(229, 231, 235, 0) 0%, rgba(26, 90, 120, 0.6) 25%, rgba(26, 90, 120, 1) 50%, rgba(26, 90, 120, 0.6) 75%, rgba(229, 231, 235, 0) 100%)',
          borderRadius: 'calc(var(--sp-md2)*0.5)',
          boxShadow: '0 4px 12px rgba(26, 90, 120, 0.15), 0 2px 6px rgba(26, 90, 120, 0.08)',
          marginLeft: 'calc(var(--sp-md2)*1)'
        }}/>
      {button && (
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs) * 2)',
            padding: 'calc(var(--sp-md2) * 1)  calc(var(--sp-md2) * 1.88679)',
            marginLeft: 'calc(var(--sp-md2) * 1.88679)',
            border: 'none',
            background: 'rgba(248, 178, 24, 1)',
            boxShadow: '0px 4px 4px 0px rgba(185, 131, 9, 0.09)',
            fontWeight: '700',
            fontSize: 'calc(var(--fs-xs) * 1.32075)',
            color: '#fff',
            textTransform: 'uppercase',
            width: 'fit-content'
          }}
          onClick={onClick}>
          {translate(button)}
        </button>
      )}
      {hyperlinkText && (
        <button
          style={{
            borderRadius: 'calc(var(--sp-md2) * 1.5)',
            padding: 'calc(var(--sp-md2) * 0.8)  calc(var(--sp-md2) * 1.5)',
            marginLeft: 'calc(var(--sp-md2) * 1.88679)',
            border: '1.5px solid #E5E7EB',
            background: '#F9FAFB',
            fontWeight: '700',
            fontSize: 'calc(var(--fs-xs) * 1.32075)',
            color: '#3127a0',
            textTransform: 'capitalize',
            width: 'fit-content',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 'calc(var(--sp-xxs) * 1.5)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#D1D5DB';
            e.currentTarget.style.backgroundColor = '#F3F4F6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#E5E7EB';
            e.currentTarget.style.backgroundColor = '#F9FAFB';
          }}
          onClick={onClick}>
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.8)', fontWeight: 700 }}>+</span>
          {translate(hyperlinkText)}
        </button>
      )}
    </div>
  );
}

function TemplateDesign({
  emailLogo,
  setEmailLogo,
  emailTemplate,
  setEmailTemplate,
  emailBackgroundColor,
  setEmailBackgroundColor,
  orderBackgroundColor,
  setOrderBackgroundColor,
  onSubmit,
  onCancel,
  orderForm,
  setOrderForm,
  addFIeld,
  onLabelChange,
  orderType,
  setOrderType,
  currencyType,
  setCurrencyType,
  currencies,
  deleteLabel,
  tab,
  onPreview,
  mandatoryFieldChange
}) {
  const whiteLabel = useSelector((state) => state.User?.branding);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const fileInputRef = useRef(null);
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const [isVinInfoOpen, setIsVinInfoOpen] = useState(false);
  const [isOrderNameCopied, setIsOrderNameCopied] = useState(false);
  const orderNameCopyTimeoutRef = useRef(null);

  const { r, g, b, a } = emailBackgroundColor;
  const { r: r1, g: g1, b: b1, a: a1 } = orderBackgroundColor;

  const onFileUpload = (e) => {
    const file = e.target.files[0];
    setLogoImage(file);
    setIsEditorOpen(true);
  };

  function imageUrl(url) {
    if (url?.type) {
      return URL.createObjectURL(url);
    }
    return url;
  }

  function templateValueChange({ target: { name, value } }) {
    setEmailTemplate({
      ...emailTemplate,
      [name]: value
    });
  }

  function complement(r, g, b) {
    const m = 255;
    return `${Math.abs(m - r)}, ${Math.abs(m - g)}, ${Math.abs(m - b)}`;
  }

  const changeOrderType = ({ target: { value: val } = {} }) => {
    setOrderType(val);
  };

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    let input = document.getElementById('myFile');
    if (input) {
      input.value = '';
    }

    setLogoImage(null);
  };

  const handleCroppedImage = (img) => {
    let arr = img.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let file = new File([u8arr], logoImage.name, { type: mime });
    setEmailLogo(file);
    handleCloseEditor();
  };

  const handleCopyOrderName = async (value) => {
    if (!value) return;
    try {
      await copyUrlToClipboard(value);
      setIsOrderNameCopied(true);
      if (orderNameCopyTimeoutRef.current) {
        clearTimeout(orderNameCopyTimeoutRef.current);
      }
      orderNameCopyTimeoutRef.current = setTimeout(() => {
        setIsOrderNameCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy order name', error);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {tab === 'emailtemplate' && (
        <>
          <div
            style={{
              display: 'inline-grid',
              alignItems: 'center',
              gridTemplateColumns: 'auto 1fr',
              width: '100%',
              marginBottom: 'calc(var(--sp-md2)*1.88679)'
            }}>
            <span
              style={{
                fontSize: 'calc(var(--fs-xs)*1.698113)',
                width: 'fit-content',
                lineHeight: 'calc(var(--sp-lg)*1.273585)',
                fontWeight: '600',
                padding:
                  'calc(var(--sp-md2)*1) calc(var(--sp-md2)*1.88679) calc(var(--sp-md2)*1) 0',
                display: 'flex',
                alignItems: 'center'
              }}>
              {translate('emailTemplate')}
            </span>

            <div style={{ 
          height: "calc(var(--fs-xs)*0.13650)", 
          background: 'linear-gradient(90deg, rgba(229, 231, 235, 0) 0%, rgba(26, 90, 120, 0.6) 25%, rgba(26, 90, 120, 1) 50%, rgba(26, 90, 120, 0.6) 75%, rgba(229, 231, 235, 0) 100%)',
          borderRadius: 'calc(var(--sp-md2)*0.5)',
          boxShadow: '0 4px 12px rgba(26, 90, 120, 0.15), 0 2px 6px rgba(26, 90, 120, 0.08)',
          marginLeft: 'calc(var(--sp-md2)*1)'
        }}/>
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              margin: '0 0 calc(var(--sp-md2) * 1.88679) 0'
            }}>
            <div
              style={{
                borderRadius: 'calc(var(--sp-md2)*1)',
                marginBottom: 'calc(var(--sp-md2)*2.5)',
                display: 'flex',
                flexDirection: 'column'
              }}>
              <div
                style={{
                  width: 'calc(var(--fs-hero) * 2.8301)',
                  height: 'calc(var(--fs-hero) * 2.8301)',
                  borderRadius: 'calc(var(--sp-xxs)*1.5)',
            background: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)',
            border: '2px solid',
            borderImage: 'linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) 1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            boxShadow: `0 0 0 1px rgba(255,255,255,0.8) inset, 
                        0 4px 6px rgba(0,0,0,0.05), 
                        0 10px 30px rgba(0,0,0,0.12),
                        0 0 20px rgba(248,178,24,0.08)`,
            transition: 'all 0.3s ease',
                  marginBottom: 'calc(var(--sp-md2) * 1.88679)'
                }}>
                {emailLogo && (
                  <img
                    src={imageUrl(emailLogo)}
                    alt="logo"
                    style={{
                      borderRadius: 'var(--sp-sm)',
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain'
                    }}
                  />
                )}
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 'calc(var(--sp-md2)*1)'
                }}>
                <div
                  style={{
                    borderRadius: 'calc(var(--sp-xxs)*2)',
                    background: `linear-gradient(0deg, ${
                      whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'
                    }, ${
                      whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'
                    }), linear-gradient(0deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.52))`,
                    fontWeight: '600',
                    fontSize: 'calc(var(--fs-xs) * 1.32075)',
                    color: '#fff',
                    textTransform: 'capitalize',
                    textAlign: 'center',
                    width: 'calc(var(--fs-hero) * 3.34905)',
                    cursor: 'pointer',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 8px 24px rgba(32, 178, 170, 0.15)',
                    transition: 'all 0.3s ease'
                    //   padding: 'calc(var(--sp-md2)*1.886792) 0',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(32, 178, 170, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(32, 178, 170, 0.15)';
                  }}>
                  {translate('update')}
                  <input
                    onChange={onFileUpload}
                    style={{
                      position: 'absolute',
                      left: 0,
                      width: '100%',
                      opacity: 0,
                      padding: 0,
                      cursor: 'pointer'
                    }}
                    type="file"
                    id="myFile"
                    name="filename"></input>
                </div>
                <button
                  style={{
                    borderRadius: 'calc(var(--sp-xxs)*2)',
                    border: 'none',
                    background:
                      'linear-gradient(0deg, #E44D29, #E44D29), linear-gradient(0deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.52))',
                    fontWeight: '600',
                    fontSize: 'calc(var(--fs-xs) * 1.32075)',
                    color: '#fff',
                    textTransform: 'capitalize',
                    textAlign: 'center',
                    width: 'calc(var(--fs-hero) * 3.34905)',
                    cursor: 'pointer',
                    boxShadow: '0 8px 24px rgba(32, 178, 170, 0.15)',
                    transition: 'all 0.3s ease',
                    padding: 'calc(var(--sp-md2)*1.132075) 0'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(32, 178, 170, 0.25)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(32, 178, 170, 0.15)';
                  }}
                  onClick={() => setEmailLogo()}>
                  {translate('delete')}
                </button>
              </div>
            </div>
            <div
              style={{
                width: '100%',
                marginTop: 'calc(var(--sp-md2)*1.88679)',
                display: 'grid',
                gridTemplateColumns: '48% 48%',
                gridAutoRows: 'auto',
                columnGap: '4%',
                rowGap: 'calc(var(--sp-md2)*1.88679)'
              }}>
              {Object.keys(emailTemplate).map((template) => (
                <TextField
                  label={template.split('_').join(' ')}
                  value={emailTemplate[template]}
                  name={template}
                  onChange={templateValueChange}
                />
              ))}
            </div>
            <div
              style={{
                margin: 'calc(var(--sp-md2) * 1.886792) 0',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 'calc(var(--sp-lg) * 1.4150943)'
              }}>
              <span
                style={{
                  fontWeight: '600',
                  color: '#4F4F4F',
                  fontSize: 'calc(var(--fs-xs) * 1.32075)',
                  lineHeight: 'var(--sp-lg)'
                }}>
                {translate('chooseBackgroundColor')}
              </span>
              <div
                style={{
                  margin: 'calc(var(--sp-lg) * 1.4150943) 0 var(--sp-md2) 0',
                  display: 'flex'
                }}>
                <div
                  style={{
                    height: 'calc(var(--fs-hero)*7.311320)',
                    width: 'calc(var(--fs-hero)*5.6603774)'
                  }}>
                  <SketchPicker
                    onChange={(color) => {
                      setEmailBackgroundColor(color.rgb);
                    }}
                    color={emailBackgroundColor}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    alignItems: 'center'
                  }}>
                  <div
                    style={{
                      height: 'calc(var(--fs-hero)*7.311320)',
                      width: 'calc(var(--fs-hero)*10.613208)',
                      backgroundColor: `rgba(${r}, ${g}, ${b}, ${a})`,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: '700',
                      fontSize: 'calc(var(--fs-xs) * 1.509433)',
                      lineHeight: 'var(--sp-lg)',
                      border: `1px solid rgba(${complement(r, g, b)}, 1)`,
                      color: `rgba(${complement(r, g, b)}, 1)`
                    }}>
                    {translate('example')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {tab === 'orderForm' && (
        <>
          <SubHeader
            label="orderForm"
            hyperlinkText="addField"
            onClick={addFIeld}
            infoContent={true}
            setIsInfoOpen={setIsInfoOpen}
          />
          <div
            style={{
              width: '100%',
              marginTop: 'calc(var(--sp-md2)*1.88679)',
              display: 'grid',
              gridTemplateColumns: '48% 48%',
              gridTemplateRows:
                'calc(var(--fs-hero)*1.1792) calc(var(--fs-hero)*1.1792) calc(var(--fs-hero)*1.1792) auto',
              columnGap: '4%',
              rowGap: 'calc(var(--sp-md2)*1.0)'
            }}>
            {orderForm.map((order) => (
              <div
                key={order.id}
                style={{
                  gridColumn: order.rows > 1 ? '1 / 3' : 'auto',
                  position: 'relative'
                }}>
                <OrderInput
                  value={order.label}
                  name={order.name ?? order.id}
                  onChange={({ target }) => onLabelChange(order.name ?? order.id, target.value)}
                  showInfo={order.name === 'vin'}
                  onInfoClick={() => setIsVinInfoOpen(true)}
                  showCopy={order.name === 'order_name'}
                  copied={isOrderNameCopied}
                  onCopy={() => handleCopyOrderName(order?.label || '')}
                />

                {order.id && (
                  <CancelIcon
                    style={{
                      position: 'absolute',
                      right: 'calc(var(--sp-sm) * -1)',
                      top: 'calc(var(--sp-xs) * -1)',
                      cursor: 'pointer',
                      background: '#fff'
                    }}
                    sx={{ fontSize: 'calc(var(--fs-xs) * 1.8867925)' }}
                    onClick={() => deleteLabel(order.id)}
                  />
                )}

                {order.id && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 'calc(var(--sp-xxs) * 1)'
                    }}>
                    <Checkbox
                      className="custom-checkbox"
                      checked={order.mandatory}
                      onChange={() => mandatoryFieldChange(order.id)}>
                      <span style={{ fontSize: 'calc(var(--fs-xs)*1.32075)', fontWeight: 400 }}>
                        {translate('requiredMessage')}
                      </span>
                    </Checkbox>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      {/*  */}
      <OrderFormInfoModal open={isInfoOpen} onClose={() => setIsInfoOpen(false)} />
      <VinInfoModal open={isVinInfoOpen} onClose={() => setIsVinInfoOpen(false)} />

      <div
        style={{
          margin: 'calc(var(--sp-lg) * 2.35849) 0 calc(var(--sp-md2) * 1.886792) 0',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}>
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            background: '#fff',
            border: '1px solid #6B7280',
            fontWeight: '600',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: '#404040',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '45%',
            cursor: 'pointer',
            padding: 'calc(var(--sp-md2)*1.415094)'
          }}
          onClick={onCancel}>
          {translate('cancel')}
        </button>
        <button
          style={{
            borderRadius: 'calc(var(--sp-xxs)*2)',
            background: `${
              whiteLabel?.web_button_color || brand?.web_button_color || 'rgba(248, 178, 24, 1)'
            }`,
            border: '1px solid rgba(255, 255, 255, 0.52)',
            fontWeight: '600',
            fontSize: 'calc(var(--fs-xs)*1.32075)',
            color: '#fff',
            textTransform: 'uppercase',
            textAlign: 'center',
            width: '45%',
            cursor: 'pointer',
            padding: 'calc(var(--sp-md2)*1.415094)'
          }}
          onClick={onPreview}>
          {translate('preview')}
        </button>
      </div>
      <Modal open={isEditorOpen} onClose={handleCloseEditor}>
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <div
            style={{
              width: '60%',
              minHeight: 'calc(var(--fs-hero)*9.433962)',
              position: 'relative',
              background: '#000',
              padding: 'calc(var(--sp-md2)*1)'
            }}>
            <ImageEditor
              img={logoImage}
              setCroppedImage={handleCroppedImage}
              handleCloseEditor={handleCloseEditor}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default TemplateDesign;
